import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=8e390656&scoped=true&"
import script from "./UserAvatar.vue?vue&type=script&lang=js&"
export * from "./UserAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e390656",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VImg,VMenu})
